import React from "react";
import "./work.css";
import WorkItem from "./WorkItem/WorkItem";
import Slider from "react-slick";
import { FormattedMessage } from "react-intl";

const Work = () => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1030,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
    ]
  };
  return (
    <section id="works" className="work-wrapper">
      <div className="container work-content">
        <div className="works">
          <div className="text-works">
            <h1 className="title">
              <FormattedMessage id="work.title" defaultMessage="Some Things I've Built." />
            </h1>
            <p>
              <FormattedMessage id="work.description" />
            </p>
          </div>
          <div className="all-my-works">
            <div className="slide-wrapper wow bounceInRight">
              <Slider {...settings}>
                <WorkItem imageclass='svgstore' link="https://svg-store.vercel.app/" title='SVG Store' description='ReactJS, NodeJS, Express, MySQL.' />
                <WorkItem imageclass='qrcode' link="https://qr-code-by-ny.vercel.app/" title='QR Code Generator' description='ReactJS' />
                <WorkItem imageclass='skyline' link="https://fa-nivoarijaona.netlify.app" title='Front End Award 2021' description='HTML, CSS, JS' />
                <WorkItem imageclass='oldportfolio' link="https://fanasina-ny.vercel.app/" title='My old portfolio' description='NextJS, webdesign with Adobe XD' />
                <WorkItem imageclass='lrcrea' link="https://lrcrea.vercel.app/" title='LRCrea Website' description='HTML, CSS, JS and JQuery' />
              </Slider>
            </div>
            <div className="slide-mobile">
              <WorkItem imageclass='svgstore' link="https://svg-store.vercel.app/" title='SVG Store' description='ReactJS, NodeJS, Express, MySQL.' />
              <WorkItem imageclass='qrcode' link="https://qr-code-by-ny.vercel.app/" title='QR Code Generator' description='ReactJS' />
              <WorkItem imageclass='skyline' link="https://fa-nivoarijaona.netlify.app" title='Front End Award 2021' description='HTML, CSS, JS' />
              <WorkItem imageclass='oldportfolio' link="https://fanasina-ny.vercel.app/" title='My old portfolio' description='NextJS, webdesign with Adobe XD' />
              <WorkItem imageclass='lrcrea' link="https://lrcrea.vercel.app/" title='LRCrea Website' description='HTML, CSS, JS and JQuery' />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
